import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';
import Loader from 'components/Loader';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ImportButtonContainer = styled.div`
  display: flex;
  height: 70px;

  @media ${({ theme }) => theme.device.mobile} {
    width: 171px;
    align-items: center;
    justify-content: center;
  }
`;

export const ImportButton: any = styled(Button)`
  @media ${({ theme }) => theme.device.desktop} {
    width: 500px;
    margin-left: auto;
  }

  @media ${({ theme }) => theme.device.mobile} {
    position: fixed;
    margin: 28px 10%;
    height: auto;
    min-height: 55px;
    font-size: 16px;
    line-height: initial;
    padding: 14px;
    left: 0;
    bottom: 0;
    right: 0;
    width: 80%;
  }
`;

ImportButton.Label = styled.span`
  height: 20px;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.expensesList.whiteBackground};
`;

ImportButton.Total = styled.span`
  height: 18px;
  font-family: Poppins;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: ${ColorPalette.HEX.White};
`;

interface StyledProps {
  grey: boolean;
}

export const Body = styled.div<StyledProps>`
  @media ${({ theme }) => theme.device.desktop} {
    max-width: 1300px;
  }

  @media ${({ theme }) => theme.device.mobile} {
    background-color: ${({ grey }) =>
      grey ? ({ theme }: any) => theme.emptyList.greyBackground : ({ theme }: any) => theme.emptyList.whiteBackground};
    flex: 1;
  }
`;

export const CustomSelectContainer = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    max-width: 500px;
    margin-bottom: 32px;
  }

  @media ${({ theme }) => theme.device.mobile} {
    margin-left: 16px;
    margin-right: 16px;
    margin-top: 32px;
  }
`;

export const CustomSelectContainerEmpty = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    max-width: 500px;
  }

  @media ${({ theme }) => theme.device.mobile} {
    margin-top: 32px;
    margin-left: 16px;
    padding-right: 32px;
    width: 100%;
    position: absolute;
    background-color: rgb(${ColorPalette.RGB.AntiFlashWhite});
  }
`;

export const EmptyListContainer = styled.div`
  @media ${({ theme }) => theme.device.mobile} {
    & > div {
      margin-top: 155px;
    }
  }
`;

export const Loading = styled(Loader)`
  height: 100%;
`;

export const LoadingContainer = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    height: 100%;
  }
`;

export const Title = styled.h5`
  text-align: center;
  font-weight: 600;
  color: ${({ theme }) => theme.expensesList.primary};
`;

export const SubTitle = styled.span`
  font-size: 12px;
  text-align: center;
  color: ${({ theme }) => theme.expensesList.secondary};
`;
